import getExtensibilityState from '../store/getExtensibilityState';
import type TaskPaneRunningInstance from '../store/schema/TaskPaneRunningInstance';
import TaskPaneType from '../store/schema/TaskPaneType';
import getProjection from 'owa-popout-v2/lib/utils/getProjection';

export function getTaskPaneRunningInstance(
    type: TaskPaneType,
    hostItemIndex: string,
    targetWindow: Window
): TaskPaneRunningInstance {
    const { taskPanes } = getExtensibilityState();
    const projection = getProjection(targetWindow);
    let tabId = projection ? projection.tabId : targetWindow === window ? 'Main' : null;

    return taskPanes?.get(tabId)?.get(type);
}

export function getTaskPaneRunningInstanceByControlId(controlId: string): TaskPaneRunningInstance {
    const { taskPanes } = getExtensibilityState();
    if (!taskPanes) {
        return null;
    }

    for (let taskPaneAddins of taskPanes.values()) {
        for (let instance of taskPaneAddins.values()) {
            if (instance && instance.controlId === controlId) {
                return instance;
            }
        }
    }
    return null;
}

export function getTaskPaneType(controlId: string): TaskPaneType {
    const { taskPanes } = getExtensibilityState();
    if (!taskPanes) {
        return null;
    }

    for (let taskPaneAddins of taskPanes.values()) {
        for (let [type, taskPaneInstance] of taskPaneAddins) {
            if (taskPaneInstance && taskPaneInstance.controlId === controlId) {
                return type;
            }
        }
    }
    return null;
}

export function getConverseTaskPaneType(type: TaskPaneType): TaskPaneType {
    return type === TaskPaneType.Persistent ? TaskPaneType.NonPersistent : TaskPaneType.Persistent;
}
